import { parseAsStringLiteral, useQueryState } from 'nuqs'
import { isIos } from '../../../shared/lib/pwa'

const DEVICES = ['android', 'ios'] as const
export type GuideDevice = (typeof DEVICES)[number]

/** `?geraet=` — the phone family the steps are written for; defaults to what is actually looking. */
export const useGuideDevice = () => {
  const [device, setDevice] = useQueryState(
    'geraet',
    parseAsStringLiteral(DEVICES).withDefault(isIos() ? 'ios' : 'android'),
  )
  return { device, setDevice }
}
